import {
    CLEAR_CREDENTIALS, EMPTY_AUTH,
    FETCH_LOGGED_IN_USER, FETCH_LOGGED_IN_USER_SUCCESS, FETCH_LOGGED_IN_USER_FAILURE,
    FETCH_LOGIN, FETCH_LOGIN_SUCCESS, FETCH_LOGIN_SUCCESS_NOT_ADMIN, FETCH_LOGIN_FAILURE,
    FETCH_RESET_PASSWORD, FETCH_RESET_PASSWORD_SUCCESS, FETCH_RESET_PASSWORD_FAILURE,
    SET_CREDENTIALS, SET_RESET_PASSWORD_DATA, SET_TOKEN, SET_USER, UPDATE_AUTH
} from './constants';

import { push } from 'react-router-redux';

import { request, requestConfig } from 'utils/request';
import { PATHS } from 'utils/paths';
import { LOCALSTORAGE } from 'utils/constants';

export const clearCredentials = () => ({
    type: CLEAR_CREDENTIALS
});

export const emptyAuth = () => ({
    type: EMPTY_AUTH
});

const fetchLoggedInUser = () => ({
    type: FETCH_LOGGED_IN_USER
});

const fetchLoggedInUserSuccess = (data) => ({
    type: FETCH_LOGGED_IN_USER_SUCCESS,
    data
});

const fetchLoggedInUserFailure = (error) => ({
    type: FETCH_LOGGED_IN_USER_FAILURE,
    error
});

const fetchLogin = () => ({
    type: FETCH_LOGIN
});

const fetchLoginSuccess = (data) => ({
    type: FETCH_LOGIN_SUCCESS,
    data
});

const fetchLoginSuccessNotAdmin = () => ({
    type: FETCH_LOGIN_SUCCESS_NOT_ADMIN
});

const fetchLoginFailure = (error) => ({
    type: FETCH_LOGIN_FAILURE,
    error
});

const fetchResetPassword = () => ({
    type: FETCH_RESET_PASSWORD
});

const fetchResetPasswordSuccess = () => ({
    type: FETCH_RESET_PASSWORD_SUCCESS
});

const fetchResetPasswordFailure = (error) => ({
    type: FETCH_RESET_PASSWORD_FAILURE,
    error
});

export const setCredentials = (data) => ({
    type: SET_CREDENTIALS,
    data
});

export const setResetPasswordData = (data) => ({
    type: SET_RESET_PASSWORD_DATA,
    data
});

export const setToken = (data) => ({
    type: SET_TOKEN,
    data
});

export const setUser = (data) => ({
    type: SET_USER,
    data
});

export const updateAuth = (data) => ({
    type: UPDATE_AUTH,
    data
});



/**
 *  ASYNC ACTIONS
 */
export const getMyProfile = (token) => (dispatch, getStore) => {
    console.log('GET-ing logged in user');

    dispatch(fetchLoggedInUser());

    return request(PATHS.user.getMyProfile(), requestConfig('GET', null, token))
        .then((response) => {
            let data = {
                user: response.data,
                company: null,
                token
            };
            localStorage.setItem(LOCALSTORAGE.ID_TOKEN, token);
            dispatch(fetchLoggedInUserSuccess(data));
            return response;
        })
        .catch((error) => {
            error.friendlyMessage = 'There was an error logging in. Please try again.';
            dispatch(fetchLoggedInUserFailure(error));
            return error;
        });
}

export const login = () => (dispatch, getStore) => {
    console.log('logging in');

    dispatch(fetchLogin());

    let credentials = getStore().auth.credentials;

    return request(PATHS.auth.login(), requestConfig('POST', credentials))
        .then((response) => {
            if(response.data.user.isAdmin === true) {
                localStorage.setItem(LOCALSTORAGE.ID_TOKEN, response.data.token);
                dispatch(setToken(response.data.token));
                dispatch(fetchLoginSuccess(response.data));
                return response;
            } else {
                dispatch(fetchLoginSuccessNotAdmin());
                dispatch(push('/download'));
                return response;
            }
        })
        .catch((error) => {
            error.friendlyMessage = 'There was an error logging in. Please try again.';
            dispatch(fetchLoginFailure(error));
            return error;
        });
};

export const resetPassword = (token) => async (dispatch, getStore) => {
    dispatch(fetchResetPassword());

    let body = JSON.parse(JSON.stringify(getStore().auth.resetPasswordData));
    body.token = token;
    delete body.password2;

    try {
        const response = await request(PATHS.auth.resetPassword(), requestConfig('POST', body));
        dispatch(fetchResetPasswordSuccess());
        return response;
    } catch (e) {
        const { error } = await e.response.json();
        e.friendlyMessage = error || 'There was an error resetting your password. Please try again.';
        dispatch(fetchResetPasswordFailure(e));
        return e;
    }
};



// WEBPACK FOOTER //
// ./src/containers/Auth/store/actions.js